import { createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';


export const showLoader = createAction(types.SHOW_LOADER);
export const attachFile = createAction(types.ATTACH_FILE);
export const selectFile = createAction(types.SELECT_FILE);
export const cleanup = createAction(types.CLEANUP);

/*
  Count number of lines of any JS type with assumption of pretty print.
  We display empty objects as 'foo: {}', but if there is even one value then 'foo: {\nx:'y'\n}'
  Same goes for arrays empty one 'foo: []', with values 'foo: [\n'x'\n]'
*/

export const countLines = (data, nested = false) => {
  if ([null, undefined].includes(data)) {
    return 1;
  }

  if (Array.isArray(data)) {
    if (data.length === 0) {
      return 1;
    }

    let count = 2;
    data.forEach((key) => {
      count += countLines(key, true);
    });
    return count;
  }

  if (typeof data === 'string') {
    return nested ? 1 : data.split('\n').length;
  }


  if (typeof data === 'object') {
    const objectKeys = Object.keys(data);
    if (objectKeys.length === 0) {
      return 1;
    }

    let count = 2;
    objectKeys.forEach((key) => {
      count += countLines(data[key], true);
    });
    return count;
  }

  // for numbers etc
  return 1;
};

const formatRdcLogLine = (line) => `${line.time} ${line.level.charAt(0)} ${line.message}`;

export const formatRdcLogFile = (lines) => lines.map(formatRdcLogLine).join('\n');
